import { isNumeric } from '../../../js/app/react/validators';

export const validateYearlySalary = (hasPartner, yearlySalary, partnerYearlySalary) => () => {
  const errors = [];
  if (!isNumeric(yearlySalary)) {
    errors.push('Please enter a valid salary');
  }
  if (hasPartner) {
    if (!isNumeric(partnerYearlySalary)) {
      errors.push('Please enter a valid salary for your partner');
    }
  }
  return errors;
};

export default null;
